import styled from 'styled-components'

import { BackgroundContainer } from '@reveni-io/reveni-ui'

export const Layout = styled(BackgroundContainer)`
  background-color: #f3f4f5;
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f3f4f5;
  padding-bottom: ${props => props.theme.whiteLabel.spacing.sp64};

  & > div {
    width: 436px;
    box-sizing: border-box;
    padding: ${props => props.theme.whiteLabel.spacing.sp32} ${props => props.theme.whiteLabel.spacing.sp24};
  }

  @media screen and (max-width: 436px) {
    & > div {
      width: 100%;
    }
  }
`

export const MerchantHeaderContainer = styled.div`
  padding: 0px !important;
`
